import { z } from 'zod';
import { NO_HOST_FLAG } from '#components/patterns/entity-select/host/SelectHost.queries.ts';
import { cidrFirewallRuleFormSchema } from '#screens/routes/form/firewall-rule/cidr-firewall-rule-form-schema.ts';
import { routableCIDRFormSchema } from '#screens/routes/form/routable-cidr/routable-cidr-schema.ts';

export const routeFormSchema = z.object({
  name: z.string().min(1, 'Please choose a name for this route').max(50, 'Name cannot be longer than 50 characters'),
  description: z.string(),
  routerHostID: z
    .custom<`host-${string}`>((val) => {
      return typeof val === 'string' ? val.startsWith('host-') : false;
    })
    .or(z.literal(NO_HOST_FLAG)),
  routableCIDRs: z
    .array(routableCIDRFormSchema)
    .max(20, 'You’ve reached the maximum of 20 routable subnets per route')
    .refine(
      (cidrs) => {
        return new Set(cidrs.map((c) => c.cidr)).size === cidrs.length;
      },
      {
        message: 'Duplicate CIDR detected',
      }
    ),
  firewallRules: z.array(cidrFirewallRuleFormSchema),
});

export type RouteFormData = z.infer<typeof routeFormSchema>;
